// extracted by LIB_CSS_EXTRACT_LOADER
import "./form_module.css"
export default {"item":"item-kXRJ67","labelError":"labelError-R0Bie6","description":"description-yOLp5t","message":"message-yxAxP5"};